module.exports = __webpack_public_path__ + "pc/img/developer.3536aea4.png";